<template>
    <div>
        <div class="card"
            v-for="(feature, index) in features"
            :key="`layer-featureable-feature-${index}`">
            <img class="card-img-top" :src="featureImage(feature)" alt="image feature">
            <div class="card-body">
                <h5 class="card-title">{{ featureName(feature) }}</h5>
                <p class="card-text">{{ featureDescription(feature) }}</p>
            </div>
            <div class="card-footer">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex justify-content-start align-items-center text-muted">
                        <img v-if="entityImage" :src="entityImage" loading="lazy" class="img-thumbnail" alt="...">
                        {{ entityName }}
                    </div>
                    <a href="#"
                        class="btn btn-secondary-main d-flex align-items-center"
                        data-toggle="tooltip-city"
                        :title="$t(`${translateID}.actions.select`)"
                        @click.prevent="onSelect(feature)">
                        <span class="code">
                            {{ featureCode(feature) }}
                        </span>
                        <i class="fas fa-right-long"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NoImageIcon from '@images/no-image.jpg';

    export default {
        mixins: [
        ],
        components:{
        },
        props: {
            translateID: {
                type: String,
                default: 'featureable',
            },
            entity: {
                type: Object,
                default: () => {
                    return {}
                },
            },
            items: {
                type: [Object, Array],
                default: () => {
                    return []
                },
            },
        },
        data() {
            return {
            }
        },
        computed: {
            noImage() {
                return NoImageIcon;
            },
            entityImage() {
                return this.entity?.image;
            },
            entityName() {
                return this.entity?.name;
            },
            featureConfig() {
                return this.entity?.featureable ?? {};
            },
            codeFeatureProperty() {
                return this.featureConfig?.property_id;
            },
            nameFeatureProperty() {
                return this.featureConfig?.property_name;
            },
            descriptionFeatureProperty() {
                return this.featureConfig?.property_description;
            },
            imageFeatureProperty() {
                return this.featureConfig?.property_image;
            },
            crs() {
                return this.items?.featureCollection?.crs ?? {};
            },
            features() {
                return this.items?.featureCollection?.features ?? []
            }
        },
        methods: {
            featureProperties(feature) {
                return feature?.properties ?? {};
            },
            featureCode(feature) {
                return this.codeFeatureProperty ? this.featureProperties(feature)[this.codeFeatureProperty] : null;
            },
            featureName(feature) {
                return this.nameFeatureProperty ? this.featureProperties(feature)[this.nameFeatureProperty] : null;
            },
            featureDescription(feature) {
                return this.descriptionFeatureProperty ? this.featureProperties(feature)[this.descriptionFeatureProperty] : null;
            },
            featureImage(feature) {
                // [TODO]
                // return this.imageFeatureProperty ? this.featureProperties(feature)[this.imageFeatureProperty] : this.noImage;
                if(this.featureProperties(feature)[this.imageFeatureProperty]) {
                    return this.featureProperties(feature)[this.imageFeatureProperty];
                }else{
                    return this.noImage;
                }
            },
            onSelect(feature) {
                this.$emit('select', Object.assign({}, {
                    feature,
                    entity: this.entity,
                    crs: this.crs,
                }));
            }
        },
        watch: {
        },
    }
</script>

<style lang="scss">
@import "@styles/bootstrap/_mixins.scss";
@import "@styles/_mixins.scss";
.layer-featureable-gallery {
    .card {
        .card-img-top {
            width: 100%;
            display: block;
            object-fit: cover;
            max-height: 60vw;

            @include sm {
                max-height: 15vw;
            }
        }
        .card-body {
            padding: 1rem;

            .card-title {
                @include font-size(1.25rem);
                font-family: var(--city-semibold-font-family);
            }
            .card-text {
                @include font-size(1rem);
                font-family: var(--city-font-family);
            }
        }
        .card-footer {
            padding: 0.5rem 1rem;

            img {
                max-width: 35px;
                margin-right: 10px;
            }

            .btn {
                padding: .3rem .6rem;
                margin: 0;
                min-width: auto;

                i {
                    @include font-size(1rem);
                    padding-left: 7px;
                }

                .code {
                    @include font-size(.875rem);
                    font-family: var(--city-bold-font-family);
                }
            }

        }
    }
}

</style>